module.exports = __webpack_public_path__ + "img/steam_ad.ba0bcf1f.gif";